import React, { ComponentType, CSSProperties } from 'react'
import { Box, FormError } from '@sketch/components'
import { ParsedError } from '@sketch/graphql-apollo/useMutation'

type ExtractProps<T> = T extends ComponentType<infer R> ? R : never
type BoxDivProps = ExtractProps<typeof Box>

type ApolloErrorComponentProps = {
  error: ParsedError
  style?: CSSProperties
} & BoxDivProps

const ApolloErrorComponent = ({
  error,
  ...props
}: ApolloErrorComponentProps) => (
  <Box {...props}>
    {!error || !error.messages || error.messages.length < 1 ? (
      <FormError>An unexpected error occurred.</FormError>
    ) : (
      error.messages.map((msg, i) => <FormError key={i}>{msg}</FormError>)
    )}
  </Box>
)

export default ApolloErrorComponent
